
import { mapGetters } from "vuex"
import { mdiMessageText, mdiClose, mdiChevronLeft } from "@mdi/js"
import FloatingChatButton from "@/components/chat/FloatingChatButton"
export default {
    name: "FloatingChat",
    components: {
        FloatingChatButton,
        ChatContainer: () => import("@/components/chat/ChatContainer"),
    },
    model: {
        prop: "openState",
        event: "input",
    },
    props: {
        /** Currently displayed business*/
        business: {
            type: Object,
            required: true,
        },
        /** If the activator button should be in fixed position */
        fixed: {
            type: Boolean,
            default: false,
        },
        /** Gives the chat spacing for fitting into bottom nav */
        bottomNav: {
            type: Boolean,
            default: false,
        },
        /** The open or close state of the whole chatcomponent */
        openState: {
            type: Boolean,
            default: false,
        },
        /** Hides the Floating action button */
        hide: {
            type: Boolean,
            default: false,
        },
        /** Remove the wrappers classes */
        inline: {
            type: Boolean,
            default: false,
        },
    },
    data: () => {
        return {
            mdiMessageText: mdiMessageText,
            mdiChevronLeft: mdiChevronLeft,
            mdiClose: mdiClose,
        }
    },
    computed: {
        ...mapGetters("chat", ["conversation", "getUnreadMessagesOfId"]),
        isDialog() {
            return this.openState && !this.$breakpoint.mdAndUp
        },
        isFloatingCard() {
            return this.openState && this.$breakpoint.mdAndUp
        },
    },
    watch: {
        openState(val) {
            if (!val) {
                this.$store.commit("chat/storeSelected")
            } else {
                this.openChat()
            }
        },
    },
    beforeDestroy() {
        this.$store.commit("chat/storeSelected")
    },
    mounted() {
        this.$store.dispatch("chat/initialize")
    },
    methods: {
        openChat() {
            let id = null
            if (this.conversation) {
                id = this.conversation.id
            }
            this.$store.dispatch("chat/selectConversation", {
                id: id,
                business: this.business,
            })
            this.$emit("input", true)
        },
        onBackBtnClick() {
            this.$store.commit("chat/storeSelected")
            this.$emit("input", false)
        },
    },
}
